import { Platform } from '@angular/cdk/platform';
import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-download-app-banner',
  standalone: true,
  imports: [],
  templateUrl: './download-app-banner.component.html',
  styleUrl: './download-app-banner.component.scss'
})
export class DownloadAppBannerComponent {
  @Output() isClosedEmitter = new EventEmitter<boolean>(false);

  constructor(private platform: Platform, private _router: Router) {}

  
  closeBanner(){
    this.isClosedEmitter.emit(true);
  }

  goToApp() {
    let category = this._router.url.split('/')[1];
    let token = this._router.url.split('/')[2];
    window.location.href = `Maqare://${category}/${token}`;
  }

  downloadApp() {
    if (this.platform.ANDROID)
      window.location.href =
        'https://play.google.com/store/apps/details?id=maqare.kmeet.app';
    if (this.platform.IOS)
      window.location.href =
        'https://apps.apple.com/us/app/maqare-%D9%85%D9%82%D8%A7%D8%B1%D8%A6/id1612866539';
  }
}
